import React, {useState} from "react";
import { Modal } from "react-bulma-components";
import { Table } from "react-bulma-components";
import { Section } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import {Icon} from "react-bulma-components";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {NotificationManager} from "react-notifications";
import {getQueryString} from "../../utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import VehicleMakePicker from "../Vehicle/VehicleMakePicker";
import VehicleModelPicker from "../Vehicle/VehicleModelPicker";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function CreatePartModal({open, setOpen, endpoint, historicPart, vehicleTypes, makes, models}) {
  const prefilledPart = historicPart ? {
    make: historicPart.part_order ? {} : historicPart.job ? historicPart.job.vehicle.make : historicPart.quote.vehicle.make,
    model: historicPart.part_order ? {} :historicPart.job ? historicPart.job.vehicle.model : historicPart.quote.vehicle.model,
    name: historicPart.name,
    part_number: historicPart.part_number,
    supplier: historicPart.supplier,
    cost: historicPart.cost,
    vehicle_type: historicPart.part_order ? {} : historicPart.job ? historicPart.job.vehicle.type : historicPart.quote.vehicle.type

  } : {
    vehicle_type: vehicleTypes[0],
    make: null,
    model: null
  }

  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  let [part, setPart] = useState(prefilledPart || {});
  const [, setTypeahead] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  let filteredModels = models ? [...models.results] : [];

  if(part.make && part.make.id && models){
    filteredModels = filteredModels.filter(model => model.make && (model.make.id === part.make.id));
  }

  const typeFields = vehicleTypes;
  const typeObjects = typeFields.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});
  let makeObjects= [];
  let modelObjects = [];
  if(makes){
    makeObjects = makes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});
  }

  if(models){
    modelObjects = models.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});
  }


  const handleMakeUpdate = (e, index) => {
    const toUpdate = {
      target: {
        name: "make",
        value: makeObjects[e.target.value]
      }
    }
    handleChange(toUpdate, index)
  }

  const handleModelUpdate = (e, index) => {
    const toUpdate = {
      target: {
        name: "model",
        value: modelObjects[e.target.value]
      }
    }
    handleChange(toUpdate, index)
  }

  const handleTypeUpdate = (e, index) => {
    const toUpdate = {
      target: {
        name: "vehicle_type",
        value: typeObjects[e.target.value]
      }
    };
    handleChange(toUpdate, index);
  };


  const onClickAction = () => {
    if (checkAllFieldsFilled()) {
      save();
      setPart({})
      setOpen(false);
    } else {
      NotificationManager.error("Please fill in all fields", "Error!", 10000);
    }
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=SP&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  }

  const handlePartSupplierSelect = supplier => {
    let newPart = {...part}
    newPart.supplier = supplier[0];
    setPart(newPart);
  };

  const handleChange = (e, index) => {
    let newPart = {...part};
    newPart[e.target.name] = e.target.value;
    setPart(newPart);
  };

  const checkAllFieldsFilled = () => {
    if (
      false
    ) {
      return false;
    }
    return true;
  };

  const save = () => {
    const url = endpoint + "partlookup";
    const queryString = getQueryString({
      name: part.name,
      part_number: part.part_number,
      make: part.make ? part.make.id : "",
      model: part.model ? part.model.id : "",
      vehicle_type: part.vehicle_type.id
    });
    return axios.get(`${endpoint}partlookup${queryString}`).then((response) => {
      if(response.data.results.length === 0) {
        const conf = {
          method: "post",
          data: part,
          url
        };
        //
        return axios(conf).then(() => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setOpen(false);
        });
      } else {
        NotificationManager.warning("This part already exists!")
      }
    });

  };

  return (
    <Modal
      closeOnBlur
      show={open}
      nClick={e => {e.stopPropagation()}}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content className="wider-modal">
        <Section style={{backgroundColor: "white"}}>
          <Heading className="is-centered">Create New Part Lookup</Heading>
          <Columns>
            <Columns.Column>
              <VehicleMakePicker
                onChange={handleMakeUpdate}
                vehicle={part}
                makes={makes}
              />
            </Columns.Column>
            <Columns.Column>
              <VehicleModelPicker
                onChange={handleModelUpdate}
                vehicle={part}
                models={{results: filteredModels}}
              />
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Control>
                  <Form.Label>Type</Form.Label>
                  <Form.Select
                    onChange={handleTypeUpdate}
                    name="vehicle_type"
                    value={part.vehicle_type ? part.vehicle_type.id : typeFields[0].id}
                  >
                    {typeFields.map(value =>
                      <option key={value.id} value={value.id}>
                        {value.name}
                      </option>
                    )}
                  </Form.Select>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Part Name</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="name"
                    onChange={handleChange}
                    value={part.name || ""}
                    required
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Part Number</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="part_number"
                    onChange={handleChange}
                    value={part.part_number || ""}
                    required
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Supplier</Form.Label>
                <Form.Control>
                  <AsyncTypeahead
                    useCache={false}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"supplier"}
                    onSearch={handleSearch}
                    onChange={handlePartSupplierSelect}
                    placeholder={"Search Supplier"}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    isLoading={isLoading}
                    selected={part.supplier && part.supplier.id ? [part.supplier] : []}
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Cost</Form.Label>
                <Form.Control className="has-icons-left">
                  <Form.Input
                    type="text"
                    name="cost"
                    onChange={handleChange}
                    value={part.cost || ""}
                    required
                  />
                  <Icon align={"left"} className={"small-icon"}>
                    <FontAwesomeIcon icon={faPoundSign}/>
                  </Icon>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Customer Charge</Form.Label>
                <Form.Control className="has-icons-left">
                  <Form.Input
                    type="text"
                    name="customer_cost"
                    onChange={handleChange}
                    value={part.customer_cost || ""}
                    required
                  />
                  <Icon align={"left"} className={"small-icon"}>
                    <FontAwesomeIcon icon={faPoundSign}/>
                  </Icon>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Button
                color="info"
                fullwidth
                onClick={() => {
                  setPart({});
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Columns.Column>
            <Columns.Column>
              <Button color="danger" fullwidth onClick={onClickAction}>
                Save Part Lookup
              </Button>
            </Columns.Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
